// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__2OcTE","boxTitle":"Qualiphy_boxTitle__2VJVg","box":"Qualiphy_box__5o-7X","toggleWrap":"Qualiphy_toggleWrap__3JAPu"};